import { z } from 'zod';
import { BaseEstimateSchema } from '../../base/base.js';
import { EstimateOpenApiSchema } from '../../base/estimate.js';
export const ListEstimatesApiSchema = {
    params: BaseEstimateSchema.pick({ entityId: true }),
    response: z.object({ estimates: z.array(EstimateOpenApiSchema) }),
};
export const ListEstimatesPathSchema = ListEstimatesApiSchema.params;
export const ListEstimatesRequestSchema = ListEstimatesPathSchema;
export const ListEstimatesResponseSchema = ListEstimatesApiSchema.response;
